import { render, staticRenderFns } from "./UnityScoresConfigs.vue?vue&type=template&id=294c6af2&"
import script from "./UnityScoresConfigs.vue?vue&type=script&lang=js&"
export * from "./UnityScoresConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports